import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import Login from './components/tabs/Login/Login';
import RegisterClient from './components/tabs/RegisterClient/RegisterClient';
import Preview from './components/tabs/Preview/Preview'
import axios from 'axios';
import Cookies from 'js-cookie';

axios.interceptors.response.use(res => res, err => {
  if (err.response && (err.response.status == 401 || err.response.status == 403)) {
    Cookies.remove("user", { path: '' })
    window.location.href = `#/`;
  }
})

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <Switch>
        <Route
          path="/home"
          render={(props) => {
            return <App {...props} />;
          }}
        />
        <Route
          path="/auth"
          render={(props) => {
            return <Login />;
          }}
        />
        <Route
          path="/register"
          render={(props) => {
            return <RegisterClient />;
          }}
        />
        <Route
          path="/preview"
          render={({value}) => {
            return <Preview value={value} />;
          }}
        />
        <Redirect to="/auth" />
      </Switch>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);